import { Col } from "reactstrap";
export const SpeakBrowserCompatibility = ({browserName, browserVersion, SystemTextContent}) => {
  return (
    <div className="pb-2 pt-1 mb-2">
            <div  className="sfw-700 mb-2 boldText">{SystemTextContent.testBrowser} </div>
            {browserName === "Chrome" && browserVersion >= 90 ? (
                <>
                    <Col className="col-12 d-flex smp-1">
                        <svg width="25" height="25" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26 0C11.6711 0 0 11.6711 0 26C0 40.3289 11.6711 52 26 52C40.3289 52 52 40.3289 52 26C52 11.6711 40.3289 0 26 0ZM26 46.2222C14.8489 46.2222 5.77778 37.1509 5.77778 26C5.77778 14.8491 14.8491 5.77778 26 5.77778C37.1509 5.77778 46.2222 14.8491 46.2222 26C46.2222 37.1509 37.1509 46.2222 26 46.2222Z" fill="#4CA96C"/>
                            <path d="M22.8802 27.5553L17.1024 21.7776L13 25.88L22.8802 35.7602L38.538 20.1024L34.4356 16L22.8802 27.5553Z" fill="#4CA96C"/>
                        </svg>
                        <p className="ms-5 italicText">You have passed our browser compatibility test.</p>
                    </Col>
                </>
            ):(
                <>
                    <Col md={8} className="d-flex">
                    <svg width="25" height="25" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26 0C11.6711 0 0 11.6711 0 26C0 40.3289 11.6711 52 26 52C40.3289 52 52 40.3289 52 26C52 11.6711 40.3289 0 26 0ZM26 46.2222C14.8489 46.2222 5.77778 37.1509 5.77778 26C5.77778 14.8491 14.8491 5.77778 26 5.77778C37.1509 5.77778 46.2222 14.8491 46.2222 26C46.2222 37.1509 37.1509 46.2222 26 46.2222Z" fill="#4CA96C"/>
                        <path d="M22.8802 27.5553L17.1024 21.7776L13 25.88L22.8802 35.7602L38.538 20.1024L34.4356 16L22.8802 27.5553Z" fill="#4CA96C"/>
                    </svg>
                    <p className="ms-5">Your browser might not be compatible. We recommend using Chrome version 90 or above. Proceed at your own risk.</p>

                    </Col>
                </>
            )}
        {/* </div> */}
    </div>
  );
};
